import { render, staticRenderFns } from "./DealerCreateCard.vue?vue&type=template&id=2f561c17&"
import script from "./DealerCreateCard.vue?vue&type=script&lang=js&"
export * from "./DealerCreateCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports